import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetPaymentDetailById,
  getAssetWithdrawalDetailById,
  getAssetWithdrawalsListItems,
} from "../../../../redux/Case/assetSlice";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function AssetWithdrawals({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const [currentRecord, setCurrentRecord] = useState(1);

  const { clientId, case_type, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const caseType = case_type || "";
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getAssetWithdrawalsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  const withdrawalId =
    subItemId || assets.withdrawals.listItems[0]?.withdrawal_id;

  useEffect(() => {
    if (!caseId || !withdrawalId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/withdrawals/${withdrawalId}/withdrawal/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/assets/${case_type}/${caseId}/withdrawal/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/withdrawals/${withdrawalId}/withdrawal/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/withdrawals/${withdrawalId}/withdrawal/view`
      );
    }
  }, [
    clientId,
    case_type,
    action,
    caseId,
    assets.withdrawals.listItems,
    withdrawalId,
    navigate,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getAssetWithdrawalDetailById(subItemId));
    }
  }, [subItemId, dispatch, assets.withdrawals.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="withdrawals"
        section="assets"
        tab={tab}
        caseType={caseType}
        caseDetail={assets?.withdrawals.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="assets"
          caseType={caseType}
          caseDetail={assets?.withdrawals.activeItem}
          caseItemList={assets?.withdrawals.listItems}
          tab={tab}
          subItem="withdrawals"
          withdrawalValue={assets.withdrawals.totalWithdrawals}
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {assets?.withdrawals.listloading ? (
            <ContentLoader />
          ) : (
            <>
              {assets?.withdrawals.listItems.length > 0 && (
                <CaseList
                  module="withdrawals"
                  data={assets?.withdrawals.listItems}
                  activeItem={assets?.withdrawals.activeItem}
                  section="assets"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && assets?.withdrawals.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default AssetWithdrawals;
